import { render, staticRenderFns } from "./CDMenu.vue?vue&type=template&id=3b56f9cc&scoped=true"
import script from "./CDMenu.vue?vue&type=script&lang=js"
export * from "./CDMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b56f9cc",
  null
  
)

export default component.exports